/* eslint-disable */

import React, { useState, useEffect, useRef } from 'react';
import { IconButton, InputBase, TextField, Typography, Button, FormControlLabel, RadioGroup, DialogContent, DialogContentText, DialogActions, Checkbox } from '@mui/material';
import Grid from '@mui/material/Grid';
import { Box } from '@mui/system';
// import DropZone from '../../Components/DropZone';
// import PageLayout from '../../Components/PageLayout';
// import DatePicker, { DateObject } from "react-multi-date-picker"
// import persian from "react-date-object/calendars/persian"
// import persian_fa from "react-date-object/locales/persian_fa"
// import persian_en from "react-date-object/locales/persian_en";
// import { ReactComponent as CalendarIcon } from "../../Assets/svg/CalendarIcon.svg";
// import { ReactComponent as CopyIcon } from "../../Assets/svg/CopyIcon.svg";
// import { ReactComponent as ContactIcon } from "../../Assets/svg/ContactIcon.svg";
import { ReactComponent as ArrowRightIcon } from "../Assets/svg/ArrowRightIcon.svg";

import { ReactComponent as CalendarIcon } from "../Assets/svg/CalendarIcon.svg";

import { ReactComponent as PersonList } from "../Assets/svg/PersonList.svg";
import { ReactComponent as DownloadIcon } from "../Assets/svg/DownloadIcon.svg";


import { ReactComponent as CloseIcon } from "../Assets/svg/CloseIcon.svg";


import { ReactComponent as SettingIcon } from "../Assets/svg/SettingIcon.svg";

// import moment from "moment-jalaali"
import moment from "jalali-moment"
import { ReactComponent as SreachIcon } from "../Assets/svg/SreachIcon.svg";

// import PropTypes from 'prop-types';
// import Tabs from '@mui/material/Tabs';
// import Tab from '@mui/material/Tab';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Slide from '@mui/material/Slide';
// import { PropertyContext } from '../../context/property-context';
// import data from '../../api/melkData.json';
// import Alert from '@mui/material/Alert';
// import Collapse from '@mui/material/Collapse';

import Cookies from 'js-cookie'

import http from '../api/axiosInstance';
// import { NumericFormat } from 'react-number-format';
// import {
//     useParams
// } from "react-router-dom";
// import { TileLayer, useMapEvents, Marker, Popup, MapContainer } from 'react-leaflet'
import { useSnackbar } from 'notistack';
// import List from '@mui/material/List';
// import ListItem from '@mui/material/ListItem';
// import ListItemButton from '@mui/material/ListItemButton';
// import ListItemIcon from '@mui/material/ListItemIcon';
// import ListItemText from '@mui/material/ListItemText';
// import ButtonNavigation from '../../Components/ButtonNavigation';
// import PropItem from '../../Components/PropItem';
import { json, useNavigate } from 'react-router-dom';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileTimePicker } from '@mui/x-date-pickers/MobileTimePicker';
import {
    Picker,
    format,
    newDate,
    DatePickerConfig,
} from '@persian-tools/persian-mobile-datepicker';
import { config } from '../Components/persian-mobile-datepicker-config'
import ModalComponent from './ModalComponent';
import { SearchCities } from './PublicFunctions';
import { ReactComponent as ArrowRightIconGreen } from "../Assets/svg/greenArrow.svg";
import { ReactComponent as WhiteSearchIcon } from "../Assets/svg/WhiteSearchIcon.svg";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { satisfactionPercent } from '../api/ListData';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});



function ShareModalCompo(props) {

    const { enqueueSnackbar } = useSnackbar();

    const [openBackdrop, setOpenBackdrop] = React.useState(false);
    const [openUsersModal, setOpenUsersModal] = useState(false)
    const [users, setUsers] = React.useState([]);
    const [UsersLoading, setUsersLoading] = React.useState(false);
    const [sendUsersLoading, setSendUsersLoading] = React.useState(false);
    const [usersSelected, setUsersSelected] = React.useState([]);

    const handleCloseBackdrop = () => {
        setOpenBackdrop(false);
    };
    const handleToggleBackdrop = () => {
        setOpenBackdrop(!openBackdrop);
    };

    const getUsers = async () => {
        handleToggleBackdrop()
        setUsersLoading(true)
        try {
            const usersRes = await http({
                url: "/users/get-my-users",
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            })
            console.log(usersRes)

            if (usersRes.data.result.Users.length) {
                console.log(" JSON.parse(Cookies.get('agency')).Id", JSON.parse(Cookies.get('agency')).Id)
                const tempUsers = usersRes.data.result.Users.filter(item => item.username != JSON.parse(Cookies.get('agency')).Username)
                setUsers(tempUsers)
            }

        } catch (e) {
            console.error(e);
        }

        handleCloseBackdrop()
        setUsersLoading(false)
    }

    const handleWrapUsers = (event, justMe = false, allUsers = false) => {
        if (justMe) {
            setUsersSelected([])
            return
        }
        if (allUsers) {
            const tmpUsers = []
            if (event.target.checked) {
                users.forEach(user => {
                    tmpUsers.push(user?.id)
                });
                setUsersSelected(tmpUsers)
            } else {
                setUsersSelected([])
            }

            return
        }
        console.log("event", event.target.checked)
        if (event.target.checked)
            setUsersSelected((prev) => ([...prev, event.target.value]));
        else {
            console.log("falseeeee")
            let tmp = [...usersSelected]
            tmp = tmp.filter(item => item != event.target.value)
            setUsersSelected(tmp)
        }
    }

    const handleSendUsers = async () => {
        handleToggleBackdrop()
        setSendUsersLoading(true)
        try {
            const response = await http({
                url: `/properties/${props.propId}/share`,
                method: "POST",
                data: {
                    Users: usersSelected
                },
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            })
            console.log(response)
            if (response?.data.result) {
                const variant = 'success'
                enqueueSnackbar('اشتراک گذاری با موفقیت ثبت شد', { variant });
            }

        } catch (e) {
            console.error(e);
        }

        handleCloseBackdrop()
        setSendUsersLoading(false)
    }

    const dataFetchedRef = useRef(false);

    useEffect(() => {
        if (dataFetchedRef.current) return;
        dataFetchedRef.current = true;
        console.log("id", props.propId)
        getUsers()
    }, [])


    useEffect(() => {
        console.log("usersSelected", usersSelected)
    }, [usersSelected])

    return (
        <>
            <Backdrop
                sx={{ color: '#fff', zIndex: 99999 }}
                open={openBackdrop}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <ModalComponent showModalState={props.showShareModal} handleModalClose={props.handleShareModalClose} modalTitle="دسترسی به مشخصات این ملک توسط" modalSubmitBtn={!sendUsersLoading && handleSendUsers} modalTitleSubmitBtn="ثبت" disableSubmitBtn={false}>
                <Box sx={{ mt: 3, color: '#8F8F8F', display: 'flex', flexDirection: 'column', gap: '15px', paddingBottom: '70px' }}>
                    <Box item sx={{ display: 'flex', justifyContent: 'center' }} >
                        <input type="checkbox" name='user' value="" id={`my`} className="d-none typeCheck" checked={!usersSelected.length} onChange={e => handleWrapUsers(e, true)} />
                        <label htmlFor={`my`} className=' typeLabel w-100' style={{ display: 'flex', justifyContent: 'center', }}>
                            <div style={{ flex: "2", paddingRight: '10px' }}>فقط خودم</div>
                        </label>
                    </Box>
                    <Box>
                        <FormControlLabel className='green-check f-16' sx={{ mr: 0 }} control={<Checkbox />} onChange={(e) => handleWrapUsers(e, false, true)} label="همه کاربران" />
                    </Box>
                    {
                        users && users.length > 0 ?
                            users.map((item, index) => (

                                <Box item sx={{ display: 'flex', justifyContent: 'center' }} key={index}>
                                    <input type="checkbox" name='user' value={item?.id} id={`user-${index}`} className="d-none typeCheck" checked={usersSelected.includes(item?.id)} onChange={e => handleWrapUsers(e)} />
                                    <label htmlFor={`user-${index}`} className=' typeLabel w-100' style={{ display: 'flex', justifyContent: 'center', }}>
                                        <div style={{ flex: "2", paddingRight: '10px' }}>{item?.username}</div>
                                    </label>
                                </Box>
                            ))
                            : !UsersLoading ? <Box sx={{ textAlign: 'center', mt: 2, width: '100%' }}>موردی یافت نشد!</Box> : ""
                    }
                    {
                        UsersLoading ? <Box sx={{ textAlign: 'center', p: 2 }}>درحال بارگیری...</Box> : ""
                    }
                </Box>
            </ModalComponent>
        </>
    );
}

export default ShareModalCompo;